// Styles
import "@mdi/font/css/materialdesignicons.css";
import { aliases, mdi } from "vuetify/iconsets/mdi-svg";
import "@/styles/main.scss";
import "vuetify/styles";
import "@/overrides.scss";

// Vuetify
import { createVuetify } from "vuetify";

// Hex equivalents of the shadcn OKLCH tokens in src/styles/tokens.scss.
// Vuetify needs hex/rgb (it derives lighten/darken variations), so keep
// these in sync with the tokens when they change.
const lightColors = {
    background: "#ffffff", // --background
    surface: "#ffffff", // --card
    "surface-variant": "#f5f5f5", // --muted
    "on-surface-variant": "#737373", // --muted-foreground
    primary: "#1d4ed8", // --primary  oklch(0.488 0.243 264.376)
    "on-primary": "#eff6ff", // --primary-foreground
    secondary: "#f4f4f5", // --secondary
    "on-secondary": "#18181b", // --secondary-foreground
    error: "#dc2626", // --destructive
    info: "#2563eb", // --chart-3
    success: "#00a63e",
    warning: "#fdc700",
};

const darkColors = {
    background: "#0a0a0a", // --background (dark)
    surface: "#171717", // --card (dark)
    "surface-variant": "#262626", // --muted (dark)
    "on-surface-variant": "#a3a3a3", // --muted-foreground (dark)
    primary: "#1e40af", // --primary (dark) oklch(0.424 0.199 265.638)
    "on-primary": "#eff6ff", // --primary-foreground (dark)
    secondary: "#27272a", // --secondary (dark)
    "on-secondary": "#fafafa", // --secondary-foreground (dark)
    error: "#f87171", // --destructive (dark)
    info: "#3b82f6", // --chart-2
    success: "#05df72",
    warning: "#ffdf20",
};

export default createVuetify({
    icons: {
        defaultSet: "mdi",
        aliases,
        sets: {
            mdi,
        },
    },
    theme: {
        defaultTheme: localStorage.getItem("color_theme") || "light",
        themes: {
            light: {
                dark: false,
                colors: lightColors,
            },
            dark: {
                dark: true,
                colors: darkColors,
            },
        },
    },
});
